var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.085,
    height: 24.021,
    viewBox: "0 0 27.085 24.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(-325.803 -514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-add",
    transform: "translate(318.603 510.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M10.2,3.6a3,3,0,0,0-3,3V24.618a3,3,0,0,0,3,3H22.213a3,3,0,0,0,3-3V11.728a3,3,0,0,0-.88-2.123L19.211,4.48a3,3,0,0,0-2.123-.88Zm7.507,9.008a1.5,1.5,0,0,0-3,0v3h-3a1.5,1.5,0,1,0,0,3h3v3a1.5,1.5,0,0,0,3,0v-3h3a1.5,1.5,0,1,0,0-3h-3Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.16,17.836.265,11.942a.907.907,0,0,1,0-1.283L1.548,9.377a.907.907,0,0,1,1.283,0L6.8,13.347l8.505-8.505a.907.907,0,0,1,1.283,0l1.283,1.283a.907.907,0,0,1,0,1.283L7.443,17.836a.907.907,0,0,1-1.283,0Z",
    transform: "translate(334.75 519.898)",
    fill: "#00c742"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFla);
export default __webpack_public_path__ + "static/media/fla.92fa5044caf776a815ba014f3b18a3bc.svg";
export { ForwardRef as ReactComponent };